import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Plug, FolderGit2, Workflow, LogOut, Terminal, Menu, X } from "lucide-react";

const nav = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, end: true, tid: "nav-dashboard" },
  { to: "/app/connections", label: "Conexões", icon: Plug, tid: "nav-connections" },
  { to: "/app/repositories", label: "Repositórios", icon: FolderGit2, tid: "nav-repositories" },
  { to: "/app/pipelines", label: "Pipelines", icon: Workflow, tid: "nav-pipelines" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const SidebarInner = (
    <>
      <div className="px-6 py-6 border-b border-line flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Terminal className="text-acid" size={22} />
          <span className="font-sans font-black text-xl tracking-tighter">PIPE<span className="text-acid">FORGE</span></span>
        </div>
        <button className="md:hidden text-zinc-400" onClick={() => setOpen(false)} data-testid="close-sidebar"><X size={20} /></button>
      </div>
      <nav className="flex-1 py-4">
        {nav.map((n) => (
          <NavLink
            key={n.to} to={n.to} end={n.end} data-testid={n.tid}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-6 py-3 text-sm uppercase tracking-widest border-l-2 transition-colors duration-150 ${
                isActive ? "border-acid text-acid bg-acid/5" : "border-transparent text-zinc-300 hover:text-foreground hover:bg-white/5"
              }`
            }
          >
            <n.icon size={18} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-line p-4">
        <div className="text-xs text-zinc-400 uppercase tracking-widest mb-1">Logado como</div>
        <div className="text-sm text-foreground truncate mb-3" data-testid="current-user-email">{user?.email}</div>
        <button
          data-testid="logout-btn"
          onClick={() => { logout(); navigate("/login"); }}
          className="w-full flex items-center justify-center gap-2 border border-line px-3 py-2 text-xs uppercase tracking-widest text-zinc-300 hover:border-destructive hover:text-destructive transition-colors"
        >
          <LogOut size={14} /> Sair
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen flex bg-void text-foreground">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex w-64 shrink-0 border-r border-line bg-surface flex-col sticky top-0 h-screen">
        {SidebarInner}
      </aside>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} />
          <aside className="absolute left-0 top-0 h-full w-64 bg-surface border-r border-line flex flex-col">
            {SidebarInner}
          </aside>
        </div>
      )}

      <div className="flex-1 min-w-0 overflow-x-hidden">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center justify-between border-b border-line bg-surface px-4 py-3 sticky top-0 z-40">
          <div className="flex items-center gap-2">
            <Terminal className="text-acid" size={18} />
            <span className="font-sans font-black text-lg tracking-tighter">PIPE<span className="text-acid">FORGE</span></span>
          </div>
          <button onClick={() => setOpen(true)} data-testid="open-sidebar" className="text-zinc-300"><Menu size={22} /></button>
        </div>
        <main>{children}</main>
      </div>
    </div>
  );
}
